<template>
    <heading-image-section
        class="heading-image-section-module"
        :desktop-image="desktopImage"
        :mobile-image="mobileImage"
        :title="attributes.heading_image_title"
    />
</template>

<script>
    import HeadingImageSection from '../../../organisms/HeadingImageSection/HeadingImageSection';
    import formatMediaObject from '../../../../utils/formatters/format-media-object';

    export default {
        name: 'heading-image-section-module',

        components: { HeadingImageSection },

        props: {
            attributes: {
                type: Object,
                required: true,
                default: () => ({}),
            },
        },

        computed: {
            /**
             * Map desktop image to heading image section format.
             *
             * @returns {object}
             */
            desktopImage() {
                return formatMediaObject.call(this, this.attributes.heading_desktop_image);
            },

            /**
             * Map mobile image to heading image section format.
             *
             * @returns {object}
             */
            mobileImage() {
                return formatMediaObject.call(this, this.attributes.heading_mobile_image);
            },
        },
    };
</script>
